<app-tool-loader [isLoading]="isLoading()" [positionUnset]="true">
  <p-toolbar>
    <ng-template #start>
      <div class="flex gap-2 toolbar-menu">
        <p-selectButton [options]="tablePlot" [ngModel]="tablePlotSelected()"
          (onChange)="tablePlotToggle($event)" [allowEmpty]="false">
        </p-selectButton>

        @if (tablePlotSelected() === 'plot') {
        <p-selectButton [options]="pressureEmw"
          [ngModel]="pressureEmwSelected()" (onChange)="pressureEmwToggle($event)"
          [allowEmpty]="false">
        </p-selectButton>
        }

        @if (pressures?.length > 1) {
        <div class="flex">
          <p-inputnumber #interpolationDepthRef placeholder="Enter TVD" (onBlur)="interpolate(interpolationDepthRef)" [minFractionDigits]="1"/>
            <p-select
              #interpSelect
              [options]="interpValueOptions"
              optionLabel="label"
              optionValue="value"
              (onChange)="selectedInterpType = interpSelect.value; interpolate(interpolationDepthRef)"
              [(ngModel)]="selectedInterpType"
              appendTo="body"
            ></p-select>
            <p-inputNumber [minFractionDigits]="1" disabled="true" [ngModel]="intepolatedValue"></p-inputNumber>
        </div>
        }
      </div>
    </ng-template>
  </p-toolbar>

  <app-units-grid-input
    [hidden]="isLoading() || tablePlotSelected() != 'table'"
    [tableTitle]="pressureType === 'porePressure' ? 'Pore Pressure' : 'Fracture Gradient'"
    [rows]="poreFracRows"
    [columns]="poreFracColumns"
    [userUnits]="_userUnits"
    [virtualScroll]="!isLoading()"
    [autoHeight]="true"
    [autoHeightOffset]="60"
    [allowDeleteRows]="true"
    [minRows]="1"
    [createRow]="createPoreFracGridRow"
    [rowCanBeDeleted]="canDeletePoreFracRow"
    [beforePasteTransform]="poreFracPasteTransform"
    [numberFormatDialogData]="poreFracPasteDialogData"
    [commitMode]="'debounced'"
    [commitDebounceMs]="300"
    (cellEdited)="onPoreFracCellEdited()"
    (rowDeleted)="onPoreFracRowDeleted($event)"
    (rowsReset)="onPoreFracRowsReset()"
    (pasteApplied)="onPoreFracPasteApplied()"
    (commitRequested)="onPoreFracGridCommit()"
  />
  
  @if (tablePlotSelected() === 'plot') {
    <app-xy-line-plot
      [plotData]="plot.data"
      [xAxisTitle]="xAxisTitle"
      [yAxisTitle]="yAxisTitle"
      [annotations]="annotations"
      [shapes]="shapes"
      [plotName]="pressureType === 'porePressure' ? plotNamePore : plotNameFrac"
      [downloadPlotName]="downloadPlotName"
      [plotTitle]="plotTitle"
      [xyLinePlotStore]="poreFracStore"
    ></app-xy-line-plot>
  }
</app-tool-loader>
